// Warns before leaving a page whose forms have unsaved edits: mark the container with data-unsaved-guard,
// and a form re-rendered with validation errors with data-unsaved="true".
addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-unsaved-guard]').forEach(editor => {
        const editableControls = form => Array.from(form.elements).filter(control =>
            control.matches('input, select, textarea') &&
            !control.matches(':disabled, [readonly], input[type="hidden"], input[type="submit"], input[type="button"], input[type="reset"], input[type="image"]')
        );
        const value = control => {
            if (control.type === 'checkbox' || control.type === 'radio') return control.checked;
            if (control.multiple) return JSON.stringify(Array.from(control.selectedOptions, option => option.value));
            return control.value;
        };
        const forms = Array.from(editor.querySelectorAll('form'));
        const initialValues = new Map(forms.map(form => [form,
            new Map(editableControls(form).map(control => [control, value(control)]))
        ]));
        // Rows added or removed by scripts count as edits too.
        const isDirty = form => {
            if (form.dataset.unsaved === 'true') return true;
            const initial = initialValues.get(form);
            const controls = editableControls(form);
            return controls.length !== initial.size || controls.some(control => initial.get(control) !== value(control));
        };
        let submittedEvent = null;

        // Keep checking values, rather than a permanent flag, so undoing an edit clears the warning.
        const clearSubmission = () => { submittedEvent = null; };
        editor.addEventListener('input', clearSubmission);
        editor.addEventListener('change', clearSubmission);
        editor.addEventListener('reset', clearSubmission);
        addEventListener('pageshow', clearSubmission);

        // A bubbling submit event also covers save buttons outside their associated form.
        addEventListener('submit', event => {
            const form = event.target;
            // A submit cancelled by another handler, e.g. a repeated click, keeps the earlier submission.
            if (!initialValues.has(form) || event.defaultPrevented) return;
            clearSubmission();
            if (!form.checkValidity()) return;

            if (forms.some(other => other !== form && isDirty(other)) &&
                !confirm('В других формах есть несохранённые изменения. Они не сохранятся при выполнении этого действия. Продолжить?')) {
                event.preventDefault();
                return;
            }

            // Retain the event so a later submit listener can still cancel navigation safely.
            submittedEvent = event;
        });

        addEventListener('beforeunload', event => {
            if (submittedEvent && !submittedEvent.defaultPrevented) return;
            if (!forms.some(isDirty)) return;
            event.preventDefault();
            event.returnValue = '';
        });
    });
});
